import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 4c0-.736.597-1.333 1.333-1.333h10.667c.736 0 1.333.597 1.333 1.333v8c0 .736-.597 1.333-1.333 1.333H2.666A1.333 1.333 0 011.333 12V4zm1.333-.333h10.667c.184 0 .333.149.333.333v.288L8 8.066 2.333 4.288V4c0-.184.15-.333.333-.333zM2.333 5.49V12c0 .184.15.333.333.333h10.667c.184 0 .333-.149.333-.333V5.49L8.277 9.083a.5.5 0 01-.555 0L2.333 5.49z",
    fill: "#000",
    fillOpacity: 0.87
  }));
}
export default SvgComponent;